// eslint-disable-next-line no-restricted-imports
import {css} from '@emotion/css'

import {cssTheme} from '@vio/atlas/themes'
import {hexToRGBAString} from '@vio/core/src/utils/css'

export const overlayStyles = css`
  height: auto !important;
  width: 624px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  [dir='rtl'] & {
    left: auto;
    right: 50%;
    transform: translate(50%, -50%);
  }

  margin: 0;
  background: ${cssTheme.colors.background.neutral.primary};
  border-radius: ${cssTheme.layout.radius.md};
  box-shadow:
    0 2px 2px 0
      ${hexToRGBAString(
        cssTheme.colors.background.neutral.inversePrimary,
        0.24
      )},
    0 0 2px 0
      ${hexToRGBAString(
        cssTheme.colors.background.neutral.inversePrimary,
        0.12
      )};
`
